export const userProfileStrings = {
  pageTitle: 'Mi perfil',
  tabsAriaLabel: 'Secciones del perfil',
  tabPersonalData: 'Datos personales',
  tabEmail: 'Correo electrónico',
  tabPassword: 'Contraseña',
  accountSectionTitle: 'Datos personales',
  accountSectionSubtitle: 'Actualice su nombre y teléfono.',
  emailSectionTitle: 'Cambiar correo',
  emailSectionSubtitle: 'Solicite un código de verificación al nuevo correo y confírmelo aquí.',
  fieldName: 'Nombre',
  fieldLastName: 'Apellidos',
  fieldPhone: 'Teléfono',
  saveProfile: 'Guardar datos',
  currentEmail: 'Correo actual',
  newEmail: 'Nuevo correo',
  newEmailPlaceholder: 'nuevo@correo.com',
  sendVerificationCode: 'Enviar código de verificación',
  emailCodeLabel: 'Código de verificación',
  confirmEmail: 'Confirmar correo',
  passwordSectionTitle: 'Contraseña',
  passwordSectionSubtitle: 'Use su contraseña actual para establecer una nueva.',
  currentPassword: 'Contraseña actual',
  newPassword: 'Nueva contraseña',
  confirmPassword: 'Confirmar nueva contraseña',
  changePassword: 'Cambiar contraseña',
  loading: 'Cargando perfil…',
  saving: 'Guardando…',
  sending: 'Enviando…',
  successTitle: 'Listo',
  profileUpdated: 'Sus datos se actualizaron correctamente.',
  passwordUpdated: 'Su contraseña se actualizó correctamente.',
  codeSent: 'Se envió un código de verificación al nuevo correo.',
  emailUpdated: 'Su correo se actualizó correctamente.',
  errorTitle: 'Error',
  passwordMinError: 'La nueva contraseña debe tener al menos 8 caracteres.',
  passwordMismatch: 'La confirmación no coincide con la nueva contraseña.',
  emailInvalid: 'Ingrese un correo válido.',
  codeLengthError: 'El código debe tener 6 dígitos.',
  apiGenericError: 'No se pudo completar la operación.',
  apiProfileLoadFailed: 'No se pudo cargar el perfil.',
  apiProfileSaveFailed: 'No se pudieron guardar los datos.',
  apiPasswordUpdateFailed: 'No se pudo actualizar la contraseña.',
  apiVerificationSendFailed: 'No se pudo enviar el código.',
  apiEmailConfirmFailed: 'No se pudo confirmar el correo.',
  cancel: 'Cancelar',
}
